import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BaseStepViewComponent } from 'app/main/components/dataset/components/common-step/base-step-view.class';
import { DatasetRecordService } from 'app/main/components/dataset/services/dataset-record.service';
import { DatasetActionContainerService } from 'app/main/components/dataset/services/dataset-action-container.service';
import { takeUntil } from 'rxjs/operators';
var TripPackageLangContentBaseClass = /** @class */ (function (_super) {
    tslib_1.__extends(TripPackageLangContentBaseClass, _super);
    function TripPackageLangContentBaseClass(appService, datasetRS, datasetACS, datasetNavigatorService, datasetService, datasetMCS, stepService, configs) {
        var _this = _super.call(this, datasetACS, datasetNavigatorService) || this;
        _this.appService = appService;
        _this.datasetRS = datasetRS;
        _this.datasetACS = datasetACS;
        _this.datasetNavigatorService = datasetNavigatorService;
        _this.datasetService = datasetService;
        _this.datasetMCS = datasetMCS;
        _this.stepService = stepService;
        _this.configs = configs;
        return _this;
    }
    TripPackageLangContentBaseClass.prototype.ngOnInit = function () {
        var _this = this;
        this.datasetACS.init({
            datasetCode: this.configs.datasetCode,
            actionCode: this.configs.actionCode,
            parentDatasetACS: this.parentDatasetACS,
            parentDatasetRS: this.parentDatasetRS,
            fetchData: true
        });
        this.datasetACS.ready
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (ready) {
            if (!ready)
                return;
            _this.datasetMCS.init({
                datasetACS: _this.datasetACS,
                datasetRS: _this.datasetRS,
                parentForeignKey: _this.configs.parentForeignKey,
                parentValueKey: _this.configs.parentValueKey
            });
            _this.datasetMCS.fetchRecord();
        });
        this.parentDatasetRS.record
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (record) {
            if (record)
                _this.datasetMCS.activeLanguageCodes = record.active_language_codes;
        });
    };
    return TripPackageLangContentBaseClass;
}(BaseStepViewComponent));
export { TripPackageLangContentBaseClass };
